
import React from "react";
import { list } from "@mc/mc-legacy";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";

export const KOMBINACE_LIST = "KombinaceList";

export function fetchCombinationsIfNeeded(force = false) {
  return (dispatch, getState) => {
    dispatch(list.SimpleListActions.fetchIfNeeded(KOMBINACE_LIST, null, (parent, filter) => {
      return QSignAdminApi.getCombinations();
    }, force));
  }

}

export function invalidate() {
  return dispatch => {
      dispatch(list.SimpleListActions.invalidate(KOMBINACE_LIST, 0));
  }
}
